import React, {useState, useEffect} from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { InputField, useFormContext } from 'clayco-controls';
import { log } from 'utils/logging';

const EmergencyContact = ({ preloadedAssociate, allMatchesConfirmed, mostRecentYesMatchedAssociate }) => {
    const {t} = useTranslation();
    const { setValue, getValues } = useFormContext();

    useEffect(() => {
        
        const defaultRecord = preloadedAssociate == null ? mostRecentYesMatchedAssociate?.emergencyContact : preloadedAssociate?.emergencyContact;

        log.trace('EmergencyContact', 'defaultRecord', defaultRecord);

        setValue('workerInfo.emergencyContact.name', defaultRecord?.name);
        setValue('workerInfo.emergencyContact.phone', defaultRecord?.phone);
    }, [preloadedAssociate, mostRecentYesMatchedAssociate, allMatchesConfirmed])


    return (
    <>
        <div className='card p-0 my-3'>
            <h6 className="card-header">
            {t('Emergency Contact Info')}
            </h6>
            <div className='card-body'>
            <Row>
                <Col>
                <div className=''>
                    <InputField placeholder={' '} label={t('Contact Name*')} name={'workerInfo.emergencyContact.name'} type='text'/>
                </div>
                </Col>
                <Col>
                <div className=''>
                    <InputField name={'workerInfo.emergencyContact.phone'} placeholder={' '} label={t('Contact Phone*')} type="tel" />
                </div>
                </Col>
            </Row>
    </div>
    </div>
    </>
    );
}

export default EmergencyContact;